var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCodeMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 5C6.64062 5 5.84375 5.75 5.75 6.71094C5.16406 6.6875 4.29688 6.52344 3.66406 5.98438C3.19531 5.5625 2.89062 4.97656 2.79688 4.20312C3.61719 4.01562 4.25 3.26562 4.25 2.39844C4.25 1.34375 3.40625 0.523438 2.375 0.523438C1.32031 0.523438 0.5 1.34375 0.5 2.375C0.5 3.28906 1.13281 4.03906 2 4.22656V8.79688C1.13281 8.96094 0.5 9.73438 0.5 10.625C0.5 11.6797 1.32031 12.5 2.375 12.5C3.40625 12.5 4.25 11.6797 4.25 10.625C4.25 9.73438 3.59375 8.96094 2.75 8.79688V6.07812C2.86719 6.24219 3.00781 6.40625 3.17188 6.54688C4.03906 7.27344 5.11719 7.46094 5.84375 7.46094C6.07812 8.21094 6.78125 8.75 7.625 8.75C8.65625 8.75 9.5 7.92969 9.5 6.875C9.5 5.84375 8.65625 5 7.625 5ZM1.25 2.375C1.25 1.76562 1.74219 1.25 2.375 1.25C2.98438 1.25 3.5 1.76562 3.5 2.375C3.5 3.00781 2.98438 3.5 2.375 3.5C1.74219 3.5 1.25 3.00781 1.25 2.375ZM3.5 10.625C3.5 11.2578 2.98438 11.75 2.375 11.75C1.74219 11.75 1.25 11.2578 1.25 10.625C1.25 10.0156 1.74219 9.5 2.375 9.5C2.98438 9.5 3.5 10.0156 3.5 10.625ZM7.625 8C6.99219 8 6.5 7.50781 6.5 6.875C6.5 6.26562 6.99219 5.75 7.625 5.75C8.23438 5.75 8.75 6.26562 8.75 6.875C8.75 7.50781 8.23438 8 7.625 8Z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCodeMerge);
export default __webpack_public_path__ + "static/media/ico-code-merge.a072e8fe6f24e3c7c1069d3b0075efd1.svg";
export { ForwardRef as ReactComponent };